<template>
  <b-container fluid  class="headerPushDown">   
    <b-container v-if="getSelectedItem" class="ml-auto mr-auto p-0">      
     <b-row class="p-0">    
      <b-col sm="12" md="12" class="p-0">
        <shop-ticket-service ref="shopTicketService" v-bind:getSelectedItemId="getSelectedItemId" v-on:setTableSelected="setIsTableSelected"/>
      </b-col>
      
      <b-col sm="12" md="12" v-if="isTableSelected">
          <!-- ADD TO CART BUTTON -->   

          <b-button v-if="!isFree && !this.$store.getters.getChachedCustomerShiftTicket" @click="addToCart" class="mt-2 text-uppercase" size="md" variant="light" style="float: right;">
              {{this.getLanguageItem['ShopUi']['buttonAddToCart']}}
          </b-button>
          
            <!-- UPDATE BUTTON & Recaptcha-->
            <b-row>
              <b-col cols="12">
                  <vue-recaptcha v-if="siteKey && this.$store.getters.getChachedCustomerShiftTicket" class="ml-0 ml-md-3 p-0 pull-right" :sitekey="siteKey" ref="recaptcha" @expired="onCaptchaExpired" @verify="onCaptchaVerified"></vue-recaptcha>

              </b-col>
              <b-col cols="12">
                <b-button v-if="!reCaptchaOK && this.$store.getters.getChachedCustomerShiftTicket" disabled @click="updateTicket" class="mt-2 text-uppercase pull-right" size="md" variant="light">
                    Umbuchen
                </b-button>

                <b-button v-if="reCaptchaOK && this.$store.getters.getChachedCustomerShiftTicket" @click="updateTicket" class="mt-2 text-uppercase pull-right" size="md" variant="light">
                    Umbuchen
                </b-button>
              </b-col>
            </b-row>

          <!-- DIRECT BOOKING MODAL -->
          <b-button v-if="isFree" to="/app/directbooking" class="mt-2 text-uppercase mr-2" size="md" variant="light" style="float: right;">
             Reservieren
          </b-button>

      </b-col>      
    </b-row>

    </b-container>

    <b-container v-if="!getSelectedItem">
        <p></p>
    </b-container>

  </b-container>
</template>

<script>
import ShopTicketService from "@/components/ShopTicketService";
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "ShopTicketView",
  components: {   
    ShopTicketService, VueRecaptcha
  },
  data() {
    return {
     /*  selectedTemplate: undefined, */
     
      booking: {
        name: '',
        emailAddress: '',
        phone: '',
        note: ''
      },
      isTableSelected: false, // used to hide buttons before a table was selected
      isTicketShift: false,
      isUpselling: false,
      upSellingProducts: undefined,

      siteKey: undefined,
      reCaptchaOK: false,
      reCaptchaToken: undefined,
    };
  },
  methods: {
    onCaptchaVerified(recaptchaToken){
        //console.log('recaptchaToken: ', recaptchaToken);
        this.reCaptchaOK = true;
        this.reCaptchaToken = recaptchaToken;
    },
    onCaptchaExpired() {
        this.$refs.recaptcha.reset();
        this.reCaptchaOK = false;
        this.reCaptchaToken = undefined;
    },
    async loadRecaptchaKeyFromServer() {
        let config = this.$store.getters.getRestHeaderConfig;
        config.params = null;

        await this.$http
            .get(this.$store.getters.getRestServerBaseUrl + "/recaptchaKey", config)
            .then(response => {
                // console.log("GET recaptchaKey: " + response.status);
                // console.log(response.data);
                this.siteKey = response.data;

                //console.log('stored recaptchaKey: ', this.$store.getters.getBasket);        
            })
            .catch(err => {
            console.log("GET recaptchaKey ERROR: ", err);

            });
    },
    setIsTableSelected: function(selected){
      //console.log('isTableSelected: ', selected);
      this.isTableSelected = selected;
    },
    async loadProductFromServer(productId) {
      let config = this.$store.getters.getRestHeaderConfig;
      config.params= {
          productId: productId,
          imageSize: "medium" /* small, medium, big */,
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/productDetail", config)
        .then(response => {
          
          // add properties we need later for counting and prices
          response.data.count = 1;
          response.data.amountOfPersons = 1; // used in Tickets
          response.data.selectedLayout = undefined;
          response.data.selectedTemplate = undefined;

          // fix GroupPerson
          if (response.data.personGroups) {
            response.data.personGroups.forEach(g => {
              // add count and sum to cachedObject
              g.count = 0;
              g.index = 0;
            });
          }

          // fix List
          if (response.data.prices) {
            response.data.prices.forEach(p => {
              p.count = 0;
            });
          }

          //console.log("GET productDetail: ", response);
          // add to cached Items, or load from cache ? FIXME
          this.$store.dispatch("updateCachedItems", response.data);

         

        })
        .catch(err => {
          console.log("GET productDetail: ", err);
         
        });
    },
    goUpselling(){
      // if any upselling products

      this.isUpselling = true;
      this.addToCart();


    },
    getUpsellingFromProductId(productId){
      this.loadUpSellingFromServer(productId);
    },
    async loadUpSellingFromServer(productId) {
       // console.log('P ID:',productId);
        
        let config = {
            header: this.$store.getters.getRestHeader,
            params: {
                productId: productId,
                localeId: this.getSelectedLanguage.ident, /* Language: de, en */
                imageSize: 'medium',
            }
        };

        await this.$http
            .get(this.$store.getters.getRestServerBaseUrl + "/upSelling", config)
            .then(response => {
              this.upSellingProducts = [];
                //console.log("GET Upselling: ", response.status, response.data);
                // upselling comes as array:
                response.data.forEach(e => {          
                    this.upSellingProducts.push(e);
                });                                 
            })
            .catch(err => {
                console.log("GET Upselling FAILED: ", err);
            });
    },    
    addToCart(){
      //console.log('add to cart:', this.getSelectedItem);

      let data = {
              productId:    this.getSelectedItem.id,
              productType:  this.getSelectedItem.type,
              count:        this.getSelectedItem.count,
      };
      // compile Person Groups data 
      data.personGroups = [];
      this.getSelectedItem.personGroups.forEach(element => {
        
        data.personGroups.push({
          id: element.id,
          numberOfPersons: element.prices[element.index].numberOfPersons
        });
      });

      //console.log('Basket to send: ', data);  
      this.postAddToBasket(data);
    },   
    async postAddToBasket(params) { 
    
      let config = this.$store.getters.getRestHeaderConfig;
      config.params = undefined; // make sure they are empty      

      //console.log('POST addToBasket:', params, config);

      await this.$http
        .post(this.$store.getters.getRestServerBaseUrl + "/addToBasket", params , config)
        .then(response => {
          //console.log("POST postAddToBasket response: "  + response.status, response);         
         
        // save response to store
        this.$store.dispatch('saveBasket', response.data);

        // we can show the CART now 
        this.$router.push('/app/cart');       

        })
        .catch(err => {
          console.log("POST postAddToBasket ERROR: ", err.response);


        });    
    },
    updateTicket(){

      let params={
        id:  this.$store.getters.getChachedCustomerShiftTicket.id,
        reCaptcha: this.reCaptchaToken,
      };
      
      
      this.postUpdateTicket(params)
    },
    async postUpdateTicket(params) { 
    
      let config = this.$store.getters.getRestHeaderConfig;
      config.params = undefined; // make sure they are empty      

      //console.log('POST updateReservation:', params, config);

      await this.$http
        .post(this.$store.getters.getRestServerBaseUrl + "/customer/updateReservation", params , config)
        .then(response => {
         // console.log("POST updateReservation response: "  + response.status, response);    

          // go Where ?
          this.$router.push('/app/customer');
response.data = '';
        })
        .catch(err => {
          console.log("POST updateReservation ERROR: ", err.response);


        });    
    },
    showModal() {
        this.$refs.BookingModal.show();
    },
    hideModal() {  
        this.$refs.BookingModal.hide();
    },
    handleSubmit() {
      // check input
      if(this.booking.email.trim() != ''){
        let params ={
          name: this.booking.name,
          emailAddress: this.booking.email,
          phone: this.booking.phone,
          note: this.booking.note,
          reCaptcha: this.reCaptchaToken,      
        };

        this.postDirectBooking(params);        
      }else{
        //console.log('E-Mail must be give!');        
      }

    }, 
    async postDirectBooking(params) {      
    
      let config = this.$store.getters.getRestHeaderConfig;
      config.params = undefined; // make sure they are empty           

      //console.log('POST bookReservation:', params, config);

      await this.$http
        .post(this.$store.getters.getRestServerBaseUrl + "/bookReservation", params , config)
        .then(response => {
          //console.log("POST bookReservation response: "  + response.status, response);         
         
         this.hideModal();
        // go somewhere ?
        this.$router.push('/app/home');
        response.data = '';
        })
        .catch(err => {
          console.log("POST bookReservation ERROR: ", err.response);
        });    
    },
    
  },
  computed: {
    getSelectedItemId: function() {
      
      if(this.$route.params.id.indexOf('_') > 0 ){
        return this.$route.params.id.slice(0, this.$route.params.id.indexOf('_'));
      }else{

        return this.$route.params.id;
      }
    },
    getSelectedItem: function() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    },
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },   
    getVoucherTemplatesData() {
      return {
        Label: this.getLanguageItem["ShopUi"]["selectTemplateLabel"],
        LabelClass: this.getLanguageItem["ShopUi"]["selectTemplateLabelClass"],
        shopItem: this.getSelectedItem
      };
    },
    hasTeamplatesItems() {
      if (this.getSelectedItem.imageTemplates != undefined && this.getSelectedItem.imageTemplates.length > 1) {
        return true;
      } else {
        return false;
      }
    },
    isCustomTextEnabled(){
      if(this.getSelectedItem.allowCustomText != undefined && this.getSelectedItem.allowCustomText != false){
        return true;
      }else{
        return false;
      }
    },
    isFree(){
      //console.log('is free? ', this.getSelectedItem.free);      
      return this.getSelectedItem.free;
    }
  },
  beforeMount() {

  },
  mounted(){


    // Edit ( only if auth ok, and cached item exists)
    if(this.$route.params.id.indexOf('_') > 0 ){ // if we have a '|' in the id...its and update/edit of ticket

      if(this.$store.getters.getCustomerLogin.authenticated && this.$store.getters.getChachedCustomerShiftTicket != undefined){

        //console.log('Updating: ', this.$store.getters.getChachedCustomerShiftTicket);
       // this.getSelectedItem.isTicketShift = this.$store.getters.getChachedCustomerShiftTicket;

        this.loadProductFromServer(this.getSelectedItemId); 
        // 

      }else if(this.$store.getters.getCustomerLogin.authenticated && this.$store.getters.getChachedCustomerShiftTicket == undefined){

        // go back to customer
        this.$router.push('/app/customer');
      }else{
        // cant be

      }

    }else{
      //console.log('regular Ticket');
              //clear any old chached one
      this.$store.dispatch('saveCustomerShiftTicket', undefined); 
      this.loadProductFromServer(this.getSelectedItemId);
    }

    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });

    this.loadRecaptchaKeyFromServer();

  }
};
</script>